import { Component, Host, h, Prop, State, Watch } from '@stencil/core';
// import { url } from 'inspector';
import '../header-component/header-component'
import '../loader-component/loader-component'


/**
 


#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/siteownerinfo-component.PNG)

#### List
List (site info)  is located in home site 

 */
@Component({
  tag: 'siteownerinfo-component',
  styleUrl: 'siteownerinfo-component.css',
  shadow: true
})

export class SiteownerinfoComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";



  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
  *Required - site url if its sp online site
  */
  @Prop() siteurl: string = "";



  @State() isLoading: boolean = true
  @State() items: []

  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;

    let siteUrl: string = "";

    if (this.online) {
      siteUrl = this.siteurl + this.webpath
    }
    else {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }


    //let hostUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    let hostUrl = new URL((window as any)._spPageContextInfo.webAbsoluteUrl)
    // let urlSearch  =hostUrl.pathname.substring (0,hostUrl.pathname.lastIndexOf('/') )


    const filter = "Show eq 1 and Title eq '" + hostUrl.pathname + "'";


    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?select=ID,Title,SiteOwnerName,SiteOwnerEmail,ContributorName,ContributorEmail&$filter=" + filter + "&$top=1", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }

  getContents = () => {

    const contentsArray = []
    this.items.forEach((item: any) => {

      let ownerNames = []
      
      if (item.SiteOwnerName)
      {
        ownerNames=item.SiteOwnerName.split(';')
      } 
      let ownerEmails=[]

      if ( item.SiteOwnerEmail)
      {
        ownerEmails = item.SiteOwnerEmail.split(';');
      }
   
      let contributorNames =[]
      if (item.ContributorName) {
        contributorNames = item.ContributorName.split(';');
      }
     
      let contributorEmails =[]
      if (item.ContributorEmail) {
        contributorEmails = item.ContributorEmail.split(';');
      }
    

      let owners = []

      ownerNames.forEach((element1,index) => {
        owners.push(element1);
        if(typeof ownerEmails[index] !== 'undefined') {
          let mailto = "mailto:" + ownerEmails[index]
          let z = <div style={{ display: "inline-block",paddingLeft:"5px",paddingRight:"5px"  }} ><span>(</span><a href={mailto} >{ownerEmails[index]} </a><span>)</span></div>
          owners.push(z);
        }

        // ownerEmails.forEach(element2 => {
        //   owners.push(element1);
        //   let mailto = "mailto:" + element2
        //   let z = <div style={{ display: "inline-block",paddingLeft:"10px" }} ><span>(</span><a href={mailto} >{element2} </a><span>)</span></div>
        //   owners.push(z);
        // });
      });

      let contributors = []
      contributorNames.forEach((element1,index) => {
        contributors.push(element1);
        if(typeof contributorEmails[index] !== 'undefined') {
          let mailto = "mailto:" + contributorEmails[index]
          let z = <div style={{ display: "inline-block",paddingLeft:"5px",paddingRight:"5px" }} ><span>(</span><a href={mailto} >{contributorEmails[index]} </a><span>)</span></div>
          contributors.push(z);
        }
        // contributorEmails.forEach(element2 => {
        //   contributors.push(element1);
        //   let mailto = "mailto:" + element2
        //   let z = <div style={{ display: "inline-block",paddingLeft:"10px" }} ><span >(</span><a href={mailto} >{element2} </a><span>)</span></div>
        //   contributors.push(z);
        // });
      });

      contentsArray.push(

        <div class="siteinfo-body">
          <div><span style={{fontSize:"16px",fontWeight:"bold"}}>Owner(s):</span> {owners}</div>
          <div><span style={{fontSize:"16px",fontWeight:"bold"}}>Contributor(s):</span> {contributors}</div>
        </div>

      )


    })

    return contentsArray


  }

  render() {

    return (
      this.isLoading ?
        <loader-component /> : this.items.length > 0 ?
        <div class="row"  >
          {this.getContents()}
        </div>
        :<div></div>

    )



  }

}

